module.exports = __webpack_public_path__ + "static/img/4.c20cd43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/4.png
// module id = e4g9
// module chunks = 1 3